// Angular
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-multicheckbox',
    templateUrl: './multicheckbox.type.component.html',
})
export class FormlyFieldMultiCheckbox extends FieldType {
    // defaultOptions = {
    //     templateOptions: {
    //         hideFieldUnderline: true,
    //         floatLabel: 'always',
    //         options: [],
    //         color: 'accent', // workaround for https://github.com/angular/components/issues/18465
    //     },
    // };
    // defaultOptions = {
    //     templateOptions: {
    //         indeterminate: true,
    //         hideLabel: true,
    //     },
    // };

    public isChecked(option: any) {
        const value = this.formControl.value;

        return value && (
            this.to.type === 'array'
                ? (value.indexOf(option.value) !== -1)
                : value[option.value]
        );
    }

    public onChange2(value, checked) {
        this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
        this.formControl.markAsTouched();
    }

    onChange(value: any, checked: boolean) {
        if (this.to.type === 'array') {
            this.formControl.patchValue(checked
                ? [...(this.formControl.value || []), value]
                : [...(this.formControl.value || [])].filter(o => o !== value),
            );
        } else {
            this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
        }
        this.formControl.markAsTouched();
    }
}
